import React from 'react';
import { Alert } from '@amzn/storm-ui';
import { AlertContainer, MessageWrapper } from './CustomAlert.styles';

export type CustomAlertProps = {
  variant?: 'error' | 'warning' | 'info' | 'success';
  alertMessage: string;
  children?: React.ReactNode;
};

export const CustomAlert = (props: CustomAlertProps) => {
  const { variant = 'info', alertMessage, children } = props;

  return (
    <AlertContainer>
      <Alert variant={variant}>
        <MessageWrapper>
          {alertMessage}
          {children && children}
        </MessageWrapper>
      </Alert>
    </AlertContainer>
  );
};
